<template>
  <section class="page-section cta">
    <div class="container">
      <div class="row">
        <div class="col-xl-9 mx-auto">
          <div class="cta-inner text-center rounded">
            <h2 class="section-heading mb-5">
              <span class="section-heading-upper">Notre engagement</span>
              <span class="section-heading-lower">Service à la personne</span>
            </h2>
            <img class="img-fluid" src="@/assets/img/sap/2.jpg" alt="Emery Paysages Acces SAP" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "AccesSAP"
}
</script>

<style lang="scss" scoped>
  .cta {
    .cta-inner {
      @media screen and (max-width: $mobile) {
        padding: 3rem 1rem;
      }
    }
  }
</style>